module.exports = __webpack_public_path__ + "img/Surecredslaptop.307ddc87.png";